{
  "title": "Browse auctions",
  "resultsCount": "{count, plural, one {# lot} other {# lots}}",
  "noResults": "No auctions match your filters.",
  "noneYet": "No auctions to show yet.",
  "noneInCategory": "No live auctions in this category yet.",
  "searchPlaceholder": "Search cards, figures, clothing and more…",
  "sortBy": "Sort by",
  "sort": {
    "endingSoon": "Ending soon",
    "newest": "Newly listed",
    "priceLow": "Price: low to high",
    "priceHigh": "Price: high to low"
  },
  "filters": {
    "category": "Category",
    "condition": "Condition",
    "grader": "Grading company",
    "grade": "Grade",
    "priceRange": "Price range",
    "productType": "Product type",
    "clearAll": "Clear all filters"
  },
  "card": {
    "viewLot": "View lot",
    "watch": "Add to watchlist",
    "unwatch": "Remove from watchlist",
    "featured": "Featured",
    "graded": "Graded by {company}",
    "certNumber": "Certification number",
    "notVerified": "Not independently verified",
    "currentBid": "Current bid",
    "starting": "Starting",
    "buyNow": "Buy It Now",
    "qty": "Qty {count}",
    "autographed": "Autographed",
    "other": "Other"
  },
  "card360": {
    "heading": "360° condition view",
    "badge": "Seller-captured · unedited",
    "sets": {
      "front_rotation": "Front",
      "back_rotation": "Back",
      "edge_inspection": "Edges",
      "corner_inspection": "Corners",
      "surface_inspection": "Surface"
    },
    "captureSets": {
      "front_rotation": "Front rotation",
      "back_rotation": "Back rotation",
      "edge_inspection": "Edges",
      "corner_inspection": "Corners",
      "surface_inspection": "Surface"
    },
    "hints": {
      "front_rotation": "Rotate the card a little between each shot until you complete a full turn of the front.",
      "back_rotation": "Same again for the reverse — buyers use this to judge centring and print lines.",
      "edge_inspection": "Close-ups along each edge. Show any whitening or nicks honestly.",
      "corner_inspection": "One close-up per corner, sharp and well lit.",
      "surface_inspection": "Angled shots that reveal scratches, dents or print defects under light."
    },
    "issues": {
      "blurred": "Looks blurred",
      "too_dark": "Too dark",
      "overexposed": "Glare / overexposed",
      "dimension_mismatch": "Different size to the rest",
      "orientation_mismatch": "Rotated the wrong way",
      "duplicate": "Near-identical to previous frame",
      "too_large": "Over 8MB",
      "corrupt": "Unreadable file",
      "bad_type": "Unsupported format"
    },
    "viewer": {
      "regionLabel": "360 degree condition view",
      "groupLabel": "{title} — 360 degree view, frame {index} of {count}",
      "frameAlt": "{title} — 360° frame {index} of {count}",
      "loading": "Loading {loaded} / {count} frames",
      "dragToRotate": "Drag to rotate",
      "play": "Play rotation",
      "pause": "Pause rotation",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "fullscreen": "Open 360° view full screen",
      "closeFullscreen": "Close full screen",
      "fullscreenTitle": "{title} — 360° condition view",
      "fullRotation": "Full 360°",
      "failed": "These 360° frames could not be loaded. Check your connection and try again."
    },
    "capture": {
      "toggleLabel": "Enable 360° condition view",
      "description": "Available for raw, ungraded cards. Buyers can spin the card and inspect corners, edges and surface before bidding — listings with 360° capture convert far better.",
      "guided": "Guided capture",
      "upload": "Upload sequence",
      "clear": "Clear set",
      "progress": "{count} / {target} frames",
      "minimum": " (minimum {min})",
      "toReview": "{count} to review",
      "blocking": "Some frames can’t be used — remove them before listing.",
      "unreadable": "Unreadable",
      "integrity": "Frames are stored exactly as captured. Filters, retouching or AI enhancement of condition media breaches the seller agreement.",
      "frameAlt": "{label} frame {index}",
      "removeFrame": "Remove frame {index}",
      "cameraUnavailable": "Camera unavailable — upload your photo sequence instead.",
      "cameraPreview": "Camera preview",
      "frameOf": "Frame {index} of {target} · rotate to about {angle}°",
      "captureFrame": "Capture frame",
      "done": "Done",
      "closeCapture": "Close capture",
      "uploadVideo": "Upload rotating video",
      "processing": "Processing",
      "videoFailed": "Video import failed",
      "cleanedToast": "Cleaned up the sequence: removed {blurred} blurred and {duplicate} duplicate frames.",
      "stage": {
        "sorting": "Sorting frames",
        "aligning": "Aligning frames",
        "extracting": "Extracting frames"
      }
    }
  },
  "inspection": {
    "heading": "AI condition inspection",
    "badge": "Informational only",
    "disclaimer": "AI inspection is informational only. It is an automated reading of the seller's photos — not an official card grade, and not affiliated with or endorsed by PSA, BGS, CGC, SGC, ACE or TAG.",
    "empty": "No condition issues were located in the seller's photos. Always review the photos yourself.",
    "pending": "Inspection queued.",
    "running": "Inspecting the photos…",
    "failed": "The inspection could not be completed.",
    "findingsCount": "{count} observation(s)",
    "centering": "Centering estimate",
    "centeringHorizontal": "Left / right",
    "centeringVertical": "Top / bottom",
    "centeringOff": "Appears off-centre",
    "centeringCentred": "Appears well centred",
    "inspect": "Inspect",
    "inspectHint": "Click an observation to rotate the card, zoom in and highlight it.",
    "markerLabel": "{defect}: {description}. Select to zoom in.",
    "severity": {
      "minor": "Minor",
      "moderate": "Moderate",
      "severe": "Severe"
    },
    "confidence": "{percent}% confidence",
    "run": "Run AI inspection",
    "rerun": "Re-run inspection",
    "runHint": "Analyses your uploaded photos for whitening, corner damage, edge wear, scratches, print lines, dents, silvering and centering.",
    "runSuccess": "Inspection complete."
  }
}
